export const AyatCard = ({ d }) => (
  <section className="surface rounded-2xl p-5 sm:p-8 fade-up" data-testid="ayat-card">
    {d.isu && (
      <div className="mb-5">
        <div className="eyebrow">Isu di lapangan</div>
        <p className="text-ink mt-1 leading-relaxed" data-testid="ayat-card-isu">{d.isu}</p>
      </div>
    )}
    {d.kenapa_ayat_ini && (
      <div className="mb-5 rounded-xl bg-q-soft p-4">
        <div className="eyebrow !text-q">Kenapa ayat ini</div>
        <p className="text-sm text-ink mt-1 leading-relaxed" data-testid="ayat-card-kenapa">{d.kenapa_ayat_ini}</p>
      </div>
    )}
    <div className="flex flex-wrap items-baseline justify-between gap-2">
      <h2 className="font-display text-xl sm:text-2xl text-ink" data-testid="ayat-card-rujukan">{d.rujukan}</h2>
      <span className="font-mono-data text-xs text-mute">{d.konteks}</span>
    </div>
    <p className="arabic mt-5 text-ink" lang="ar" dir="rtl" data-testid="ayat-card-arab">{d.arab}</p>
    <p className="mt-5 text-base text-ink/90 leading-relaxed" data-testid="ayat-card-terjemahan">{d.terjemahan}</p>
    <p className="mt-4 text-xs text-mute font-mono-data">Terjemahan: Abdullah Muhammad Basmeih · Teks: mushaf imla'i</p>
    {d.note && <p className="mt-3 text-sm text-warn bg-warn-soft rounded-lg p-3" data-testid="ayat-card-note">{d.note}</p>}
  </section>
);
